import * as React from 'react';
import './index.css';
export default function PlateHead(props) {
    var rollTypeInvoiceData = props.rollTypeInvoiceData, rollInvoiceDataColumns = props.rollInvoiceDataColumns;
    return (React.createElement("div", { className: 'roll_plate_head' },
        React.createElement("div", { className: 'roll_plate_invoice_title' }, rollTypeInvoiceData.typeText),
        React.createElement("div", { className: 'roll_plate_head_item_box' }, rollInvoiceDataColumns.map(function (item, index) {
            return (React.createElement("div", { className: 'roll_plate_head_item', key: index, style: {
                    justifyContent: item.alignText ? item.alignText : 'flex-start'
                } },
                React.createElement("div", { className: 'roll_plate_head_item_title' }, item.title),
                React.createElement("div", { className: 'roll_plate_head_item_text' }, item.render ? item.render(rollTypeInvoiceData[item.dataIndex]) :
                    rollTypeInvoiceData[item.dataIndex])));
        }))));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/RollTypeInvoicePlate/PlateHead/index.js
// module id = 4199
// module chunks = 0